module.exports = __webpack_public_path__ + "img/Icon-order-list-down.fd0f8558.svg";